import React from 'react';
import { Radio, Space, Tag } from 'antd';
import { ClockCircleOutlined, RocketOutlined, DollarOutlined } from '@ant-design/icons';
import { useTranslationWithNamespace } from '../../../hooks/useTranslationWithNamespace';
import { SpeedSelectorProps } from './WithdrawalModalTypes';

/**
 * Transaction speed selector component
 */
const WithdrawalModalSpeedSelector: React.FC<SpeedSelectorProps> = ({
  selectedSpeed,
  handleSpeedChange
}) => {
  const { t } = useTranslationWithNamespace('wallet');

  return (
    <Radio.Group 
      value={selectedSpeed} 
      onChange={(e) => handleSpeedChange(e.target.value)} 
      buttonStyle="solid"
    >
      <Radio.Button value="slow">
        <Space>
          <ClockCircleOutlined />
          {t('sendTransaction.slow', 'Slow')}
          <Tag color="green">{t('sendTransaction.cheapest', 'Cheapest')}</Tag>
        </Space>
      </Radio.Button>
      <Radio.Button value="medium">
        <Space>
          <RocketOutlined />
          {t('sendTransaction.medium', 'Medium')}
          <Tag color="blue">{t('sendTransaction.recommended', 'Recommended')}</Tag>
        </Space>
      </Radio.Button>
      <Radio.Button value="fast">
        <Space>
          <DollarOutlined />
          {t('sendTransaction.fast', 'Fast')}
          <Tag color="orange">{t('sendTransaction.fastest', 'Fastest')}</Tag>
        </Space>
      </Radio.Button>
    </Radio.Group>
  );
};

export default WithdrawalModalSpeedSelector;
